let lenisInstance = null;

export function registerLenis(lenis) {
    lenisInstance = lenis;
}

export function getLenis() {
    return lenisInstance;
}

export function scrollToY(targetY, { smooth = true } = {}) {
    const prefersReducedMotion =
        typeof window !== 'undefined' &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const useSmooth = smooth && !prefersReducedMotion;

    if (lenisInstance) {
        lenisInstance.scrollTo(targetY, { immediate: !useSmooth });
        return;
    }

    window.scrollTo({ top: targetY, behavior: useSmooth ? 'smooth' : 'auto' });
}

export function scrollToElement(element, { offset = 80, smooth = true } = {}) {
    if (!element) return;
    const bodyRect = document.body.getBoundingClientRect().top;
    const elementRect = element.getBoundingClientRect().top;
    const elementPosition = elementRect - bodyRect;
    scrollToY(elementPosition - offset, { smooth });
}

export function scrollToTop({ smooth = true } = {}) {
    scrollToY(0, { smooth });
}